import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Field } from "react-final-form";

import { entitySelector } from "../../modules/SelectEntityByType/state/selectors";
import { createRequiredValidator } from "../forms/validator";
import { Select } from "../forms/fields";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const DestinationObjectPropertyCodeField = ({
    objectStructuresValues,
    name = "destination_object_property_code",
    label = "Object Property *",
    isRequired = true
}) => {
    const filters = useSelector(entitySelector);

    const filterData = filters[FiltersFieldsTypes.objectStructures] || {};

    const { properties } = filterData;

    const entityOptions = useMemo(() => {
        if(properties && properties[objectStructuresValues]?.properties){
            return properties[objectStructuresValues]?.properties.map(({ code, name }) => ({ value: code, label: name }));
        }

        return [];
    }, [ properties, objectStructuresValues ]);

    return (
        <Field
            isClearable
            isSearchable
            options={entityOptions}
            component={Select}
            name={name}
            isDisabled={!objectStructuresValues}
            validate={isRequired && createRequiredValidator(label)}
            label={label}
            placeholder="Select"
        />
    );
};
